import classnames from "classnames";
import { useEffect, useRef } from "react";
import { GripVerticalIcon } from "lucide-react";

import { useSortableItemContext } from "./sortable-list";
import styles from "./sortable-list.module.css";

interface DragHandleProps {
  className?: string;
}

const DragHandle = ({ className }: DragHandleProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const itemContext = useSortableItemContext();
  const isEnabled = !!itemContext;

  useEffect(() => {
    if (ref.current && itemContext) {
      itemContext.dragRef(ref.current);
    }
  }, [itemContext]);

  return (
    <div
      ref={ref}
      className={classnames(
        styles.dragHandle,
        { [styles.dragHandleDisabled]: !isEnabled },
        className,
      )}
      aria-label="Drag to reorder"
    >
      <GripVerticalIcon size={16} />
    </div>
  );
};

export default DragHandle;
